export const STORY_COPY = {
  TEXT_PLACEHOLDER: 'Add text…',
  CITE_PLACEHOLDER: 'Optional source',
  INITIAL_PLACEHOLDER: 'Tell the story of this exhibition…',
  CAPTION_PLACEHOLDER: 'Optional caption',
} as const;
